import React from 'react';
import { Card, CardContent, Typography, Box, SvgIcon } from '@mui/material';

interface ReportData {
    year: string;
    value: number;
}

interface ReportsCardProps {
    data: ReportData[];
}

const cardSx = {
    width: 360,
    height: 240,
};

const ReportsCard: React.FC<ReportsCardProps> = ({ data }) => {
    return (
        <Card sx={cardSx}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Reports</Typography>
                    <SvgIcon
                        viewBox="0 0 67 67"
                        style={{ width: '50.545px', height: '42.358px' }}
                    >
                        <path d="M10.0904 41.8542C9.28772 41.8542 8.59628 41.5641 8.0161 40.9839C7.43593 40.4037 7.14584 39.7123 7.14584 38.9096V10.0904C7.14584 9.28771 7.43593 8.59627 8.0161 8.01609C8.59628 7.43592 9.28772 7.14583 10.0904 7.14583H20.554C20.4886 6.0464 20.8434 5.09106 21.6182 4.27984C22.393 3.46828 23.3536 3.0625 24.5 3.0625C25.6597 3.0625 26.6269 3.46828 27.4017 4.27984C28.1762 5.09106 28.5243 6.0464 28.446 7.14583H38.9096C39.7123 7.14583 40.4037 7.43592 40.9839 8.01609C41.5641 8.59627 41.8542 9.28771 41.8542 10.0904V38.9096C41.8542 39.7123 41.5641 40.4037 40.9839 40.9839C40.4037 41.5641 39.7123 41.8542 38.9096 41.8542H10.0904ZM10.0904 39.5374H38.9096C39.0665 39.5374 39.2104 39.4721 39.3414 39.3414C39.4721 39.2104 39.5374 39.0664 39.5374 38.9096V10.0904C39.5374 9.93356 39.4721 9.78962 39.3414 9.65861C39.2104 9.52795 39.0665 9.46262 38.9096 9.46262H10.0904C9.93357 9.46262 9.78963 9.52795 9.65862 9.65861C9.52796 9.78962 9.46262 9.93356 9.46262 10.0904V38.9096C9.46262 39.0664 9.52796 39.2104 9.65862 39.3414C9.78963 39.4721 9.93357 39.5374 10.0904 39.5374ZM14.8021 33.9621H27.8136V31.6458H14.8021V33.9621ZM14.8021 25.6581H34.1979V23.3419H14.8021V25.6581ZM14.8021 17.3542H34.1979V15.0379H14.8021V17.3542ZM24.4959 8.6143C24.9563 8.6143 25.3601 8.44552 25.7071 8.10797C26.0542 7.77007 26.2278 7.36633 26.2278 6.89675C26.2278 6.42683 26.0542 6.02309 25.7071 5.68553C25.3601 5.34764 24.9563 5.17869 24.4959 5.17869C24.0352 5.17869 23.636 5.34764 23.2985 5.68553C22.9609 6.02309 22.7922 6.42683 22.7922 6.89675C22.7922 7.36633 22.9609 7.77007 23.2985 8.10797C23.636 8.44552 24.0352 8.6143 24.4959 8.6143Z" fill="#6D6D6D" />
                    </SvgIcon>
                </Box>
            </CardContent>

            <CardContent>
                <Box
                    display="flex"
                    alignItems="flex-end"
                    justifyContent="space-between"
                    height={140}
                    px={2}
                >
                    {data.map((item) => (
                        <Box key={item.year} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="caption">{item.value}</Typography>
                            <Box
                                bgcolor="#2e7d32"
                                sx={{
                                    width: 20,
                                    height: `${item.value / 2}px`,
                                    borderRadius: 1,
                                    my: 0.5,
                                }}
                            />
                            <Typography variant="caption">{item.year}</Typography>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export default ReportsCard;
